// ignore-string-externalization

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from '../../lib/nextCompat';

class ScrollToTop extends Component<React.PropsWithChildren<{}>> {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    children: PropTypes.element.isRequired,
  };

  componentDidUpdate(prevProps: $TSFixMe) {
    if (
      (this.props as $TSFixMe).location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
